import { NodeType, Point3D } from "./model";
import styles from "./node-panel.module.css";
import { useContext } from "react";
import { GraphContext } from "./data";
import { MolStarWrapper } from "./molstar-component";
import { NodeLabels } from "./node-labels";

export type NotePanelProps = {
  point?: Point3D | null;
  onClose?: () => void;
};

export const NotePanel = ({ point, onClose }: NotePanelProps) => {
  const display = !point ? "none" : "flex";
  return (
    <div
      className={"node-panel " + styles.panel}
      style={{ display }}
    >
      <MolStarWrapper dataId={point?.id} />
      <div className={styles.panelPointClose} onClick={onClose}>
        X
      </div>
      <div className={styles.pointTitle}>
        Node Information
      </div>
      <div className={styles.pointList}>
        {point && Object.entries(point).filter(([key, value]) => !key.startsWith(':') && value).map(([key, value]) => (
          <div key={key}>{key}: {value as string}</div>
        ))}
      </div>
    </div>
  );
};
